/**
 * Initialize the order filter.
 *
 * @param {Function} callback The callback function to execute after processing.
 */
const init = (callback) => {
	// Event handler for change in order filter
	const orderFilter = document.querySelector('.js-gsfc-filter-order');
	if (orderFilter) {
		orderFilter.addEventListener('change', async function () {
			// Scroll to feed anchor with smooth behavior
			document.getElementById('filterWrapper').scrollIntoView({
				behavior: 'smooth',
			});
			await process(this);
			callback();
		});
	}
};

/**
 * Process the order filter.
 *
 * @param {HTMLElement} elem The element representing the order filter.
 * @return {Promise} A Promise that resolves after processing the filter.
 */
const process = (elem) => {
	return new Promise((resolve) => {
		const value = elem.value;

		// Update global filters based on selected value
		global.filters.order = value === 'date-asc' ? '' : value;
		resolve();
	});
};

/**
 * Update the order filter based on global filters.
 */
const update = () => {
	// Update order filter value if global order filter is set
	const orderFilter = document.querySelector('.js-gsfc-filter-order');
	if (
		orderFilter &&
		global.filters.order !== undefined &&
		global.filters.order !== ''
	) {
		orderFilter.value = global.filters.order;
	}
};

// Export the order filter methods
export default { init, update };
